import { createFileRoute } from '@tanstack/react-router';
import { pullRequestsRouteOptions } from '../-workspaceRouteOptions';

export const Route = createFileRoute('/_authed/$orgSlug/pull-requests')({
  ...pullRequestsRouteOptions,
});
